<template>
  <div>
    <el-button
      @click="
        () => {
          $router.back();
        }
      "
      type="text"
      style="display:flex"
      icon="el-icon-arrow-left"
    >
      返回
    </el-button>
    <div class="table-box">
      <!--查询-->
      <div class="search-box">
        <div class="search-left">
          <div>
            <span>任务时间：</span>
            <el-select
              :disabled="true"
              v-model="searchQuery.month"
              placeholder="请选择"
            >
              <el-option
                v-for="date in taskDates"
                :key="date"
                :label="date"
                :value="date"
              />
            </el-select>
          </div>
        </div>
        <!-- <div class="search-right">
          <el-button type="primary" @click="getDataList">搜索</el-button>
        </div> -->
      </div>
      <div>
        <el-table
          :data="taskList"
          border
          style="width: 100%"
          :stripe="true"
          :highlight-current-row="false"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="80px"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in titleListComputer"
            :key="index"
            :show-overflow-tooltip="true"
            align="center"
            :label="item"
          >
            <template slot-scope="{ row }">
              <span>{{ row[index] }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="200" align="center"> -->
          <!-- <template slot-scope="scope"> -->
          <!-- <el-button type="text" size="small" @click="check(scope.row)">查看</el-button> -->
          <!-- <el-button :disabled="scope.row.auditGongyeStatus !== 1" type="text" size="small" @click="approve(2,scope.row)">通过</el-button>
            <rejectComponent :disabled="scope.row.auditGongyeStatus !== 1" @withdraw="(item)=>approve(3,scope.row,0,item)"/> -->
          <!-- </template> -->
          <!-- </el-table-column> -->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import dateFormat from '@/tools/dateFormat';

import { project, channel } from '@/api/ajax';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import searchbar from '@/components/Survey/searchbar';
import rejectComponent from '@/components/Task/components/reject.vue';
import approvalFlagMixins from '@/Mixin/approvalFlagMixins';

export default {
  mixins: [makeSure, taskRecordHandles, initSearch, approvalFlagMixins],
  data() {
    return {
      n: 1,
      taskList: [],
      titleList: [],
      tableData: [],
      ruleForm: {}, // 用户信息
      getList: channel.selectMonthTask, // 获取列表的AJAX
      searchQuery: {
        projectId: this.$route.query.projectId,
        userId: this.$route.query.userId,
        month: this.$route.query.month, // 选中任务月度
        taskMonth: this.$route.query.month, // ???
        statementId: this.$route.query.statementId
      },
      prop: {
        label: 'projectName',
        code: 'id'
      },
      searchAjax: project.crmProjectList,
      extraObj: {
        type: 1
      },
      taskDates: [] // 任务月度集合
    };
  },
  components: {
    dicSelect,
    searchbar,
    rejectComponent
  },
  computed: {
    titleListComputer() {
      return this.titleList[0];
    }
  },
  methods: {
    changeMonth() {
      this.searchQuery.month = this.searchQuery.taskMonth;
    },
    getDataList() {
      channel.selectMonthTask(this.searchQuery).then(res => {
        let { taskList, titleList } = res.data.data;
        this.$set(this, 'taskList', taskList);
        this.$set(this, 'titleList', titleList);
      });
    },
    dateChange(val) {},
    saveProId(val) {
      this.searchQuery.projectId = val.id;
    },
    exportEvent() {
      if (this.searchQuery.projectId && this.searchQuery.month) {
        let queryString = this.$querystring.stringify(this.searchQuery);
        window.open(project.exportHgtgExcel + '?' + queryString);
      } else {
        this.$message.error('请选择条件');
      }
    },
    saveEnterpriseId(val) {
      //保存
      this.searchQuery.enterpriseId = val.id;
    },
    add() {
      this.$router.push({
        name: 'salerAdd'
      });
    },
    pass(scope, status) {
      let delEvent = scope => {
        let { $index, row } = scope;
        visit
          .pass({
            id: row.id,
            status
          })
          .then(res => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.makeSureEvent(delEvent, scope);
    }
  },
  filters: {
    transAuditStatus(val) {
      if (val == 1) {
        return '审核中';
      } else if (val == 2) {
        return '审核通过';
      } else if (val == 3) {
        return '审核未通过';
      }
    }
  },
  async created() {
    // const { pdata } = await channel.getMonthTask(this.$route.query);
    // this.taskDates = pdata.map(item => item.month);
    // this.searchQuery.month = this.searchQuery.taskMonth = this.taskDates[0];
    this.getDataList();
  },
  watch: {
    n() {
      if (this.searchQuery.month) {
        this.getDataList();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
</style>
